import { TextField,Select,Box,styled, } from "@mui/material";
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';

export const StyledTextField = styled(TextField)({
    width: "300px",
    "& .MuiOutlinedInput-input": {
      height: "34px",
      padding: 0,
      margin: 0,
      marginLeft: 14,
    },
  });
  
  export const StyledSelectField = styled(Select)({
    width: "300px",
    height: "34px",
  });
  export const StyledInputRow = styled(Box)({
    display: "flex",
    margin: "22px 350px 22px 44px",
    justifyContent: "space-between",
  });
  export const styles = {
    InputLabel: {
      mx: 10,
      my: 0.5,
      fontFamily: "Calibri",
      fontSize: "18px",
      fontWeight: "400",
      lineHeight: "21.1px",
    },
    Icon: { height: 20, width: 20, left: 2, fill: "var(--Dark-Gray, #666461)" },
  };

  export const StyledDateTimePicker = styled(DesktopDateTimePicker)({
    width: "300px",
    "& .MuiOutlinedInput-input": {
      height: "34px",
      padding: 0,
      margin: 0,
      marginLeft: 14,
    },
  });
  
  export const RequiredField = styled("span")(() => ({
    color: "#E52B24",
    fontFamily: "Calibri",
    lineHeight: "normal",
    fontStyle: "normal",
  }));
  